export default __webpack_public_path__ + "static/media/pr.97c673a8.svg";